@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(-781_362_325)
internal val Res.string.account__delete: StringResource by lazy {
      StringResource("string:account__delete", "account__delete", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1898, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1610, 43),
      ))
    }

@delegate:ResourceContentHash(1_045_730_590)
internal val Res.string.account__delete_confirm: StringResource by lazy {
      StringResource("string:account__delete_confirm", "account__delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1442, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1178, 51),
      ))
    }

@delegate:ResourceContentHash(-2_117_572_570)
internal val Res.string.account__delete_message: StringResource by lazy {
      StringResource("string:account__delete_message", "account__delete_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1498, 307),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1230, 295),
      ))
    }

@delegate:ResourceContentHash(1_140_856_352)
internal val Res.string.account__delete_summary: StringResource by lazy {
      StringResource("string:account__delete_summary", "account__delete_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1806, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1526, 83),
      ))
    }

@delegate:ResourceContentHash(-281_823_278)
internal val Res.string.account__export: StringResource by lazy {
      StringResource("string:account__export", "account__export", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2115, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1819, 43),
      ))
    }

@delegate:ResourceContentHash(580_914_801)
internal val Res.string.account__export_done: StringResource by lazy {
      StringResource("string:account__export_done", "account__export_done", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1942, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1654, 48),
      ))
    }

@delegate:ResourceContentHash(-1_630_364_478)
internal val Res.string.account__export_summary: StringResource by lazy {
      StringResource("string:account__export_summary", "account__export_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1991, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1703, 115),
      ))
    }

@delegate:ResourceContentHash(-950_892_963)
internal val Res.string.activity__badge_earned: StringResource by lazy {
      StringResource("string:activity__badge_earned", "activity__badge_earned", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2167, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1863, 66),
      ))
    }

@delegate:ResourceContentHash(-389_203_715)
internal val Res.string.activity__completed: StringResource by lazy {
      StringResource("string:activity__completed", "activity__completed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2238, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1930, 55),
      ))
    }

@delegate:ResourceContentHash(1_156_310_069)
internal val Res.string.activity__followed: StringResource by lazy {
      StringResource("string:activity__followed", "activity__followed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2298, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1986, 62),
      ))
    }

@delegate:ResourceContentHash(-597_133_536)
internal val Res.string.activity__library_added: StringResource by lazy {
      StringResource("string:activity__library_added", "activity__library_added", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2369, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2049, 75),
      ))
    }

@delegate:ResourceContentHash(-950_452_207)
internal val Res.string.activity__library_imported: StringResource by lazy {
      StringResource("string:activity__library_imported", "activity__library_imported", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2449, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2125, 66),
      ))
    }

@delegate:ResourceContentHash(1_289_414_283)
internal val Res.string.activity__list_created: StringResource by lazy {
      StringResource("string:activity__list_created", "activity__list_created", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2524, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2192, 66),
      ))
    }

@delegate:ResourceContentHash(-251_949_580)
internal val Res.string.activity__list_item_added: StringResource by lazy {
      StringResource("string:activity__list_item_added", "activity__list_item_added", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2595, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2259, 65),
      ))
    }

@delegate:ResourceContentHash(-1_845_435_321)
internal val Res.string.activity__rated: StringResource by lazy {
      StringResource("string:activity__rated", "activity__rated", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2669, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2325, 55),
      ))
    }

@delegate:ResourceContentHash(1_399_463_952)
internal val Res.string.activity__reviewed: StringResource by lazy {
      StringResource("string:activity__reviewed", "activity__reviewed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2733, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2381, 50),
      ))
    }

@delegate:ResourceContentHash(-1_682_178_254)
internal val Res.string.activity__status_changed: StringResource by lazy {
      StringResource("string:activity__status_changed", "activity__status_changed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2792, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2432, 64),
      ))
    }

@delegate:ResourceContentHash(-1_797_753_095)
internal val Res.string.activity__unknown_game: StringResource by lazy {
      StringResource("string:activity__unknown_game", "activity__unknown_game", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2865, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2497, 38),
      ))
    }

@delegate:ResourceContentHash(-2_058_482_903)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2536, 32),
      ))
    }

@delegate:ResourceContentHash(209_227_226)
internal val Res.string.auth__cancel: StringResource by lazy {
      StringResource("string:auth__cancel", "auth__cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2908, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2569, 28),
      ))
    }

@delegate:ResourceContentHash(1_199_600_752)
internal val Res.string.auth__continue: StringResource by lazy {
      StringResource("string:auth__continue", "auth__continue", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2941, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2598, 34),
      ))
    }

@delegate:ResourceContentHash(-503_367_399)
internal val Res.string.auth__deep_link_host: StringResource by lazy {
      StringResource("string:auth__deep_link_host", "auth__deep_link_host", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2633, 36),
      ))
    }

@delegate:ResourceContentHash(477_575_500)
internal val Res.string.auth__deep_link_path: StringResource by lazy {
      StringResource("string:auth__deep_link_path", "auth__deep_link_path", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2670, 40),
      ))
    }

@delegate:ResourceContentHash(-1_847_789_023)
internal val Res.string.auth__deep_link_scheme: StringResource by lazy {
      StringResource("string:auth__deep_link_scheme", "auth__deep_link_scheme", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2711, 46),
      ))
    }

@delegate:ResourceContentHash(1_359_308_456)
internal val Res.string.auth__logging_in: StringResource by lazy {
      StringResource("string:auth__logging_in", "auth__logging_in", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2976, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2758, 52),
      ))
    }

@delegate:ResourceContentHash(948_171_762)
internal val Res.string.auth__login: StringResource by lazy {
      StringResource("string:auth__login", "auth__login", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3332, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3054, 27),
      ))
    }

@delegate:ResourceContentHash(2_102_583_110)
internal val Res.string.auth__login_failed: StringResource by lazy {
      StringResource("string:auth__login_failed", "auth__login_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3041, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2811, 42),
      ))
    }

@delegate:ResourceContentHash(-1_054_141_600)
internal val Res.string.auth__login_required_message: StringResource by lazy {
      StringResource("string:auth__login_required_message", "auth__login_required_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3088, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2854, 92),
      ))
    }

@delegate:ResourceContentHash(-2_093_001_357)
internal val Res.string.auth__login_required_title: StringResource by lazy {
      StringResource("string:auth__login_required_title", "auth__login_required_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3201, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2947, 54),
      ))
    }

@delegate:ResourceContentHash(404_366_476)
internal val Res.string.auth__login_success: StringResource by lazy {
      StringResource("string:auth__login_success", "auth__login_success", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3260, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3002, 51),
      ))
    }

@delegate:ResourceContentHash(-1_501_134_743)
internal val Res.string.auth__logout: StringResource by lazy {
      StringResource("string:auth__logout", "auth__logout", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3425, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3163, 32),
      ))
    }

@delegate:ResourceContentHash(1_959_435_641)
internal val Res.string.auth__logout_confirm_message: StringResource by lazy {
      StringResource("string:auth__logout_confirm_message", "auth__logout_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3360, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3082, 80),
      ))
    }

@delegate:ResourceContentHash(-324_978_084)
internal val Res.string.badge__completed_1: StringResource by lazy {
      StringResource("string:badge__completed_1", "badge__completed_1", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3567, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3305, 54),
      ))
    }

@delegate:ResourceContentHash(-472_908_151)
internal val Res.string.badge__completed_10: StringResource by lazy {
      StringResource("string:badge__completed_10", "badge__completed_10", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3511, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3253, 51),
      ))
    }

@delegate:ResourceContentHash(1_962_609_920)
internal val Res.string.badge__completed_100: StringResource by lazy {
      StringResource("string:badge__completed_100", "badge__completed_100", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3454, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3196, 56),
      ))
    }

@delegate:ResourceContentHash(153_186_793)
internal val Res.string.badge__completed_50: StringResource by lazy {
      StringResource("string:badge__completed_50", "badge__completed_50", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3626, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3360, 51),
      ))
    }

@delegate:ResourceContentHash(1_629_368_160)
internal val Res.string.badge__first_list: StringResource by lazy {
      StringResource("string:badge__first_list", "badge__first_list", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3682, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3412, 41),
      ))
    }

@delegate:ResourceContentHash(1_860_755_494)
internal val Res.string.badge__game_100_hours: StringResource by lazy {
      StringResource("string:badge__game_100_hours", "badge__game_100_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3724, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3454, 57),
      ))
    }

@delegate:ResourceContentHash(-1_171_651_453)
internal val Res.string.badge__library_100: StringResource by lazy {
      StringResource("string:badge__library_100", "badge__library_100", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3782, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3512, 58),
      ))
    }

@delegate:ResourceContentHash(1_267_602_028)
internal val Res.string.badge__platforms_5: StringResource by lazy {
      StringResource("string:badge__platforms_5", "badge__platforms_5", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3841, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3571, 42),
      ))
    }

@delegate:ResourceContentHash(1_066_210_894)
internal val Res.string.badge__reviews_1: StringResource by lazy {
      StringResource("string:badge__reviews_1", "badge__reviews_1", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3934, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3656, 40),
      ))
    }

@delegate:ResourceContentHash(-933_392_277)
internal val Res.string.badge__reviews_10: StringResource by lazy {
      StringResource("string:badge__reviews_10", "badge__reviews_10", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3888, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3614, 41),
      ))
    }

@delegate:ResourceContentHash(-1_232_575_541)
internal val Res.string.badge__reviews_50: StringResource by lazy {
      StringResource("string:badge__reviews_50", "badge__reviews_50", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3983, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3697, 41),
      ))
    }

@delegate:ResourceContentHash(-1_097_275_723)
internal val Res.string.calendar__backlog_only: StringResource by lazy {
      StringResource("string:calendar__backlog_only", "calendar__backlog_only", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4029, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3739, 50),
      ))
    }

@delegate:ResourceContentHash(-1_677_434_797)
internal val Res.string.calendar__empty: StringResource by lazy {
      StringResource("string:calendar__empty", "calendar__empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4145, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3843, 51),
      ))
    }

@delegate:ResourceContentHash(420_500_727)
internal val Res.string.calendar__empty_hint: StringResource by lazy {
      StringResource("string:calendar__empty_hint", "calendar__empty_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4088, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3790, 52),
      ))
    }

@delegate:ResourceContentHash(-1_282_305_674)
internal val Res.string.calendar__jump_to_day: StringResource by lazy {
      StringResource("string:calendar__jump_to_day", "calendar__jump_to_day", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4201, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3895, 41),
      ))
    }

@delegate:ResourceContentHash(1_415_670_972)
internal val Res.string.calendar__today: StringResource by lazy {
      StringResource("string:calendar__today", "calendar__today", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4251, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3937, 31),
      ))
    }

@delegate:ResourceContentHash(-1_973_917_668)
internal val Res.string.collection_type__series: StringResource by lazy {
      StringResource("string:collection_type__series", "collection_type__series", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4283, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3969, 39),
      ))
    }

@delegate:ResourceContentHash(1_735_629_335)
internal val Res.string.comments__delete: StringResource by lazy {
      StringResource("string:comments__delete", "comments__delete", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4503, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4181, 32),
      ))
    }

@delegate:ResourceContentHash(1_316_869_812)
internal val Res.string.comments__delete_confirm_message: StringResource by lazy {
      StringResource("string:comments__delete_confirm_message", "comments__delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4323, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4009, 104),
      ))
    }

@delegate:ResourceContentHash(1_510_378_347)
internal val Res.string.comments__delete_confirm_title: StringResource by lazy {
      StringResource("string:comments__delete_confirm_title", "comments__delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4432, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4114, 66),
      ))
    }

@delegate:ResourceContentHash(-853_417_074)
internal val Res.string.comments__edit: StringResource by lazy {
      StringResource("string:comments__edit", "comments__edit", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4811, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4461, 30),
      ))
    }

@delegate:ResourceContentHash(1_495_171_959)
internal val Res.string.comments__edit_confirm_message: StringResource by lazy {
      StringResource("string:comments__edit_confirm_message", "comments__edit_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4540, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4214, 106),
      ))
    }

@delegate:ResourceContentHash(-1_800_664_746)
internal val Res.string.comments__edit_confirm_title: StringResource by lazy {
      StringResource("string:comments__edit_confirm_title", "comments__edit_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4651, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4321, 60),
      ))
    }

@delegate:ResourceContentHash(-559_898_520)
internal val Res.string.comments__edited: StringResource by lazy {
      StringResource("string:comments__edited", "comments__edited", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4716, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4382, 32),
      ))
    }

@delegate:ResourceContentHash(-320_529_707)
internal val Res.string.comments__editing: StringResource by lazy {
      StringResource("string:comments__editing", "comments__editing", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4757, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4415, 45),
      ))
    }

@delegate:ResourceContentHash(-1_065_038_167)
internal val Res.string.comments__empty: StringResource by lazy {
      StringResource("string:comments__empty", "comments__empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4846, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4492, 47),
      ))
    }

@delegate:ResourceContentHash(-423_739_864)
internal val Res.string.comments__format_bold: StringResource by lazy {
      StringResource("string:comments__format_bold", "comments__format_bold", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4902, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4540, 37),
      ))
    }

@delegate:ResourceContentHash(1_367_619_971)
internal val Res.string.comments__format_code: StringResource by lazy {
      StringResource("string:comments__format_code", "comments__format_code", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4944, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4578, 37),
      ))
    }

@delegate:ResourceContentHash(1_363_485_107)
internal val Res.string.comments__format_italic: StringResource by lazy {
      StringResource("string:comments__format_italic", "comments__format_italic", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4982, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4616, 39),
      ))
    }

@delegate:ResourceContentHash(350_548_544)
internal val Res.string.comments__format_link: StringResource by lazy {
      StringResource("string:comments__format_link", "comments__format_link", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5026, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4656, 37),
      ))
    }

@delegate:ResourceContentHash(494_239_352)
internal val Res.string.comments__format_list: StringResource by lazy {
      StringResource("string:comments__format_list", "comments__format_list", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5064, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4694, 49),
      ))
    }

@delegate:ResourceContentHash(-1_806_605_871)
internal val Res.string.comments__format_numbered: StringResource by lazy {
      StringResource("string:comments__format_numbered", "comments__format_numbered", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5114, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4744, 53),
      ))
    }

@delegate:ResourceContentHash(-1_014_792_072)
internal val Res.string.comments__format_strikethrough: StringResource by lazy {
      StringResource("string:comments__format_strikethrough", "comments__format_strikethrough", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5168, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4798, 58),
      ))
    }

@delegate:ResourceContentHash(-880_855_350)
internal val Res.string.comments__has_spoiler: StringResource by lazy {
      StringResource("string:comments__has_spoiler", "comments__has_spoiler", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5219, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4857, 53),
      ))
    }

@delegate:ResourceContentHash(1_810_302_937)
internal val Res.string.comments__hide_replies: StringResource by lazy {
      StringResource("string:comments__hide_replies", "comments__hide_replies", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5273, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4911, 46),
      ))
    }

@delegate:ResourceContentHash(-1_881_517_908)
internal val Res.string.comments__hint: StringResource by lazy {
      StringResource("string:comments__hint", "comments__hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5328, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4958, 42),
      ))
    }

@delegate:ResourceContentHash(1_691_370_958)
internal val Res.string.comments__in_reply_to: StringResource by lazy {
      StringResource("string:comments__in_reply_to", "comments__in_reply_to", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5375, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5001, 53),
      ))
    }

@delegate:ResourceContentHash(-1_421_881_521)
internal val Res.string.comments__link_add: StringResource by lazy {
      StringResource("string:comments__link_add", "comments__link_add", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5429, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5055, 30),
      ))
    }

@delegate:ResourceContentHash(1_601_895_867)
internal val Res.string.comments__link_url: StringResource by lazy {
      StringResource("string:comments__link_url", "comments__link_url", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5468, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5086, 38),
      ))
    }

@delegate:ResourceContentHash(1_590_243_682)
internal val Res.string.comments__new: StringResource by lazy {
      StringResource("string:comments__new", "comments__new", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5507, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5125, 37),
      ))
    }

@delegate:ResourceContentHash(437_116_157)
internal val Res.string.comments__rejected: StringResource by lazy {
      StringResource("string:comments__rejected", "comments__rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5549, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5163, 86),
      ))
    }

@delegate:ResourceContentHash(181_474_188)
internal val Res.string.comments__reply: StringResource by lazy {
      StringResource("string:comments__reply", "comments__reply", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5702, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5304, 31),
      ))
    }

@delegate:ResourceContentHash(-27_002_171)
internal val Res.string.comments__replying_to: StringResource by lazy {
      StringResource("string:comments__replying_to", "comments__replying_to", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5652, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5250, 53),
      ))
    }

@delegate:ResourceContentHash(313_676_757)
internal val Res.string.comments__save: StringResource by lazy {
      StringResource("string:comments__save", "comments__save", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5738, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5336, 30),
      ))
    }

@delegate:ResourceContentHash(441_004_116)
internal val Res.string.comments__send: StringResource by lazy {
      StringResource("string:comments__send", "comments__send", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5769, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5367, 30),
      ))
    }

@delegate:ResourceContentHash(794_280_603)
internal val Res.string.comments__spoiler: StringResource by lazy {
      StringResource("string:comments__spoiler", "comments__spoiler", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5891, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5481, 45),
      ))
    }

@delegate:ResourceContentHash(715_030_547)
internal val Res.string.comments__spoiler_hint: StringResource by lazy {
      StringResource("string:comments__spoiler_hint", "comments__spoiler_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5800, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5398, 82),
      ))
    }

@delegate:ResourceContentHash(-507_299_649)
internal val Res.string.comments__title: StringResource by lazy {
      StringResource("string:comments__title", "comments__title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5941, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5527, 35),
      ))
    }

@delegate:ResourceContentHash(1_509_764_413)
internal val Res.string.common__back: StringResource by lazy {
      StringResource("string:common__back", "common__back", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5977, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5563, 28),
      ))
    }

@delegate:ResourceContentHash(994_594_407)
internal val Res.string.common__more_options: StringResource by lazy {
      StringResource("string:common__more_options", "common__more_options", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6010, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5592, 44),
      ))
    }

@delegate:ResourceContentHash(209_227_226)
internal val Res.string.common_cancel: StringResource by lazy {
      StringResource("string:common_cancel", "common_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6059, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5637, 29),
      ))
    }

@delegate:ResourceContentHash(-1_086_729_147)
internal val Res.string.common_clear: StringResource by lazy {
      StringResource("string:common_clear", "common_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6093, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5667, 28),
      ))
    }

@delegate:ResourceContentHash(2_090_574_620)
internal val Res.string.common_close: StringResource by lazy {
      StringResource("string:common_close", "common_close", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6126, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5696, 28),
      ))
    }

@delegate:ResourceContentHash(-594_151_976)
internal val Res.string.common_loading: StringResource by lazy {
      StringResource("string:common_loading", "common_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6155, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5725, 34),
      ))
    }

@delegate:ResourceContentHash(81_670_336)
internal val Res.string.common_ok: StringResource by lazy {
      StringResource("string:common_ok", "common_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6198, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5760, 21),
      ))
    }

@delegate:ResourceContentHash(-1_630_794_658)
internal val Res.string.common_select: StringResource by lazy {
      StringResource("string:common_select", "common_select", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6267, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5825, 29),
      ))
    }

@delegate:ResourceContentHash(1_440_159_278)
internal val Res.string.common_select_date: StringResource by lazy {
      StringResource("string:common_select_date", "common_select_date", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6220, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5782, 42),
      ))
    }

@delegate:ResourceContentHash(-697_090_034)
internal val Res.string.date__input_placeholder: StringResource by lazy {
      StringResource("string:date__input_placeholder", "date__input_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6301, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5855, 47),
      ))
    }

@delegate:ResourceContentHash(643_779_385)
internal val Res.string.emoji__group_activities: StringResource by lazy {
      StringResource("string:emoji__group_activities", "emoji__group_activities", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6349, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5903, 47),
      ))
    }

@delegate:ResourceContentHash(-1_677_896_292)
internal val Res.string.emoji__group_animals_nature: StringResource by lazy {
      StringResource("string:emoji__group_animals_nature", "emoji__group_animals_nature", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6393, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5951, 59),
      ))
    }

@delegate:ResourceContentHash(1_489_276_882)
internal val Res.string.emoji__group_animated: StringResource by lazy {
      StringResource("string:emoji__group_animated", "emoji__group_animated", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6453, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6011, 41),
      ))
    }

@delegate:ResourceContentHash(-1_214_827_478)
internal val Res.string.emoji__group_flags: StringResource by lazy {
      StringResource("string:emoji__group_flags", "emoji__group_flags", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6495, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6053, 34),
      ))
    }

@delegate:ResourceContentHash(366_034_789)
internal val Res.string.emoji__group_food_drink: StringResource by lazy {
      StringResource("string:emoji__group_food_drink", "emoji__group_food_drink", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6534, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6088, 51),
      ))
    }

@delegate:ResourceContentHash(-1_259_763_708)
internal val Res.string.emoji__group_objects: StringResource by lazy {
      StringResource("string:emoji__group_objects", "emoji__group_objects", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6586, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6140, 40),
      ))
    }

@delegate:ResourceContentHash(1_765_415_410)
internal val Res.string.emoji__group_people_body: StringResource by lazy {
      StringResource("string:emoji__group_people_body", "emoji__group_people_body", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6627, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6181, 52),
      ))
    }

@delegate:ResourceContentHash(63_552_605)
internal val Res.string.emoji__group_smileys_emotion: StringResource by lazy {
      StringResource("string:emoji__group_smileys_emotion", "emoji__group_smileys_emotion", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6680, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6234, 64),
      ))
    }

@delegate:ResourceContentHash(205_449_861)
internal val Res.string.emoji__group_symbols: StringResource by lazy {
      StringResource("string:emoji__group_symbols", "emoji__group_symbols", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6745, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6299, 40),
      ))
    }

@delegate:ResourceContentHash(-1_733_745_621)
internal val Res.string.emoji__group_travel_places: StringResource by lazy {
      StringResource("string:emoji__group_travel_places", "emoji__group_travel_places", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6786, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6340, 58),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("account__delete", Res.string.account__delete)
  map.put("account__delete_confirm", Res.string.account__delete_confirm)
  map.put("account__delete_message", Res.string.account__delete_message)
  map.put("account__delete_summary", Res.string.account__delete_summary)
  map.put("account__export", Res.string.account__export)
  map.put("account__export_done", Res.string.account__export_done)
  map.put("account__export_summary", Res.string.account__export_summary)
  map.put("activity__badge_earned", Res.string.activity__badge_earned)
  map.put("activity__completed", Res.string.activity__completed)
  map.put("activity__followed", Res.string.activity__followed)
  map.put("activity__library_added", Res.string.activity__library_added)
  map.put("activity__library_imported", Res.string.activity__library_imported)
  map.put("activity__list_created", Res.string.activity__list_created)
  map.put("activity__list_item_added", Res.string.activity__list_item_added)
  map.put("activity__rated", Res.string.activity__rated)
  map.put("activity__reviewed", Res.string.activity__reviewed)
  map.put("activity__status_changed", Res.string.activity__status_changed)
  map.put("activity__unknown_game", Res.string.activity__unknown_game)
  map.put("app_name", Res.string.app_name)
  map.put("auth__cancel", Res.string.auth__cancel)
  map.put("auth__continue", Res.string.auth__continue)
  map.put("auth__deep_link_host", Res.string.auth__deep_link_host)
  map.put("auth__deep_link_path", Res.string.auth__deep_link_path)
  map.put("auth__deep_link_scheme", Res.string.auth__deep_link_scheme)
  map.put("auth__logging_in", Res.string.auth__logging_in)
  map.put("auth__login", Res.string.auth__login)
  map.put("auth__login_failed", Res.string.auth__login_failed)
  map.put("auth__login_required_message", Res.string.auth__login_required_message)
  map.put("auth__login_required_title", Res.string.auth__login_required_title)
  map.put("auth__login_success", Res.string.auth__login_success)
  map.put("auth__logout", Res.string.auth__logout)
  map.put("auth__logout_confirm_message", Res.string.auth__logout_confirm_message)
  map.put("badge__completed_1", Res.string.badge__completed_1)
  map.put("badge__completed_10", Res.string.badge__completed_10)
  map.put("badge__completed_100", Res.string.badge__completed_100)
  map.put("badge__completed_50", Res.string.badge__completed_50)
  map.put("badge__first_list", Res.string.badge__first_list)
  map.put("badge__game_100_hours", Res.string.badge__game_100_hours)
  map.put("badge__library_100", Res.string.badge__library_100)
  map.put("badge__platforms_5", Res.string.badge__platforms_5)
  map.put("badge__reviews_1", Res.string.badge__reviews_1)
  map.put("badge__reviews_10", Res.string.badge__reviews_10)
  map.put("badge__reviews_50", Res.string.badge__reviews_50)
  map.put("calendar__backlog_only", Res.string.calendar__backlog_only)
  map.put("calendar__empty", Res.string.calendar__empty)
  map.put("calendar__empty_hint", Res.string.calendar__empty_hint)
  map.put("calendar__jump_to_day", Res.string.calendar__jump_to_day)
  map.put("calendar__today", Res.string.calendar__today)
  map.put("collection_type__series", Res.string.collection_type__series)
  map.put("comments__delete", Res.string.comments__delete)
  map.put("comments__delete_confirm_message", Res.string.comments__delete_confirm_message)
  map.put("comments__delete_confirm_title", Res.string.comments__delete_confirm_title)
  map.put("comments__edit", Res.string.comments__edit)
  map.put("comments__edit_confirm_message", Res.string.comments__edit_confirm_message)
  map.put("comments__edit_confirm_title", Res.string.comments__edit_confirm_title)
  map.put("comments__edited", Res.string.comments__edited)
  map.put("comments__editing", Res.string.comments__editing)
  map.put("comments__empty", Res.string.comments__empty)
  map.put("comments__format_bold", Res.string.comments__format_bold)
  map.put("comments__format_code", Res.string.comments__format_code)
  map.put("comments__format_italic", Res.string.comments__format_italic)
  map.put("comments__format_link", Res.string.comments__format_link)
  map.put("comments__format_list", Res.string.comments__format_list)
  map.put("comments__format_numbered", Res.string.comments__format_numbered)
  map.put("comments__format_strikethrough", Res.string.comments__format_strikethrough)
  map.put("comments__has_spoiler", Res.string.comments__has_spoiler)
  map.put("comments__hide_replies", Res.string.comments__hide_replies)
  map.put("comments__hint", Res.string.comments__hint)
  map.put("comments__in_reply_to", Res.string.comments__in_reply_to)
  map.put("comments__link_add", Res.string.comments__link_add)
  map.put("comments__link_url", Res.string.comments__link_url)
  map.put("comments__new", Res.string.comments__new)
  map.put("comments__rejected", Res.string.comments__rejected)
  map.put("comments__reply", Res.string.comments__reply)
  map.put("comments__replying_to", Res.string.comments__replying_to)
  map.put("comments__save", Res.string.comments__save)
  map.put("comments__send", Res.string.comments__send)
  map.put("comments__spoiler", Res.string.comments__spoiler)
  map.put("comments__spoiler_hint", Res.string.comments__spoiler_hint)
  map.put("comments__title", Res.string.comments__title)
  map.put("common__back", Res.string.common__back)
  map.put("common__more_options", Res.string.common__more_options)
  map.put("common_cancel", Res.string.common_cancel)
  map.put("common_clear", Res.string.common_clear)
  map.put("common_close", Res.string.common_close)
  map.put("common_loading", Res.string.common_loading)
  map.put("common_ok", Res.string.common_ok)
  map.put("common_select", Res.string.common_select)
  map.put("common_select_date", Res.string.common_select_date)
  map.put("date__input_placeholder", Res.string.date__input_placeholder)
  map.put("emoji__group_activities", Res.string.emoji__group_activities)
  map.put("emoji__group_animals_nature", Res.string.emoji__group_animals_nature)
  map.put("emoji__group_animated", Res.string.emoji__group_animated)
  map.put("emoji__group_flags", Res.string.emoji__group_flags)
  map.put("emoji__group_food_drink", Res.string.emoji__group_food_drink)
  map.put("emoji__group_objects", Res.string.emoji__group_objects)
  map.put("emoji__group_people_body", Res.string.emoji__group_people_body)
  map.put("emoji__group_smileys_emotion", Res.string.emoji__group_smileys_emotion)
  map.put("emoji__group_symbols", Res.string.emoji__group_symbols)
  map.put("emoji__group_travel_places", Res.string.emoji__group_travel_places)
}
